import React from 'react';

import { getNavigationPanelSelectedTab } from '../../../../store/selectors/navigationPanelSelectors';
import { useAppSelector } from '../../../hooks';
import { Visible } from '../../../Visible';
import ComponentPanel from './ComponentPanel';
import LayoutPanel from './LayoutPanel';

export type NavigationPanelTab = 'layout' | 'component';

interface Props {
  gridHeight: number;
}

export const NavigationPanel = ({ gridHeight }: Props) => {
  const selectedTab = useAppSelector(getNavigationPanelSelectedTab);

  // The selected tab is null until the `startup` action occurs.
  if (selectedTab == null) return null;

  return (
    <>
      <Visible when={selectedTab === 'layout'}>
        <LayoutPanel gridHeight={gridHeight} />
      </Visible>

      <Visible when={selectedTab === 'component'}>
        <ComponentPanel gridHeight={gridHeight} />
      </Visible>
    </>
  );
};
